<template>
  <aside class="main-sidebar datasidebar sidebar-dark-primary sidebar-color elevation-4" >
    <div class="sidebar main-sidebar" style="overflow-y:scroll;">
      <router-link
        :to="{ name: 'Dashboard' }"
        class="brand-link border-0 w-100 text-center"
      >
      <div id="logo" class="d-flex justify-content-center align-items-center">
        <img
          src="@/assets/image/artrade-logo-only-min.png"
          alt="Artrade Logo"
          style="width: 50%"
        />
        <p class="pt-2 bold">Ar<span class="text-danger">T</span>rade <br> <small>Smart Solution</small></p>
      </div>
      </router-link>
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="true"
        >
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'Dashboard' }" class="nav-link" active-class="route-is-active"
              exact>
              <i class="nav-icon fas fa-th"></i>
              <p>Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'Profile' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-user"></i>
              <p>Profile</p>
            </router-link>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'Bank' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-money-check-alt"></i>
              <p>Bank Account</p>
            </router-link>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'IntroducingBroker' }" class="nav-link" active-class="route-is-active">
              <!-- <i class="nav-icon fas fa-robot"></i> -->
              <i class="nav-icon fa fa-user-secret"></i>
              <p>Personel</p>
            </router-link>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'ListConfiguration' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-cogs"></i>
              <p>Agent Configuration</p>
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link :to="{ name: 'Disbursement' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-coins"></i>
              <p>Disbursement</p>
            </router-link>
          </li> -->
          <li class="nav-item" @click="ChangeLink('collapseDisbursement')">
            <a class="nav-link" active-class="route-is-active">
                    <i class="nav-icon fas fa-coins"></i>
                    <p>Disbursement</p>
                    <i class="nav-icon fas fa-chevron-right" v-if="linkActive != 'collapseDisbursement'"></i>
                    <i class="nav-icon fas fa-chevron-down" v-else-if="linkActive == 'collapseDisbursement'"></i>
                </a>
                <div id="collapseDisbursement" :class="linkActive == 'collapseDisbursement' ? 'show' : ''" class="collapse">
                    <div class="bg-black border-grey py-2 collapse-inner rounded">
                        <router-link :to="{ name: 'Disbursement' }" class="nav-link pl-4" active-class="route-is-active">
                          <!-- <i class="nav-icon fas fa-coins"></i> -->
                          <p>My Disbursement</p>
                        </router-link>
                        <router-link :to="{ name: 'AgentDisbursement' }" class="nav-link pl-4" active-class="route-is-active">
                          <!-- <i class="nav-icon fas fa-coins"></i> -->
                          <p>Agent Disbursement</p>
                        </router-link>
                    </div>
                </div>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'IbRequest' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-hand-paper"></i>
              <p>Career Request</p>
            </router-link>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'IbUpLevel' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-user-check"></i>
              <p>Advancement Request</p>
            </router-link>
          </li>
          <li class="nav-item" @click="ChangeLink('')">
            <router-link :to="{ name: 'Rate' }" class="nav-link" active-class="route-is-active">
              <i class="nav-icon fas fa-star"></i>
              <p>Rate</p>
            </router-link>
          </li>
          <li class="nav-item" @click="logout()">
            <button @click="logout()" class="nav-link">
              <i class="nav-icon fas fa-sign-out-alt"></i>
              <p>Log Out</p>
            </button>
          </li>
        </ul>
        
      </nav>
    </div>
  </aside>
</template>

<script>

import swal from 'sweetalert'
export default {
  name: "SideBar",
  data(){
    return{
      linkActive : ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  methods: {
    ChangeLink(data){
      if(data == 'collapseDisbursement' && this.linkActive == 'collapseDisbursement'){
        this.linkActive = ''
      }else if(data == 'collapseDisbursement' && this.linkActive != 'collapseDisbursement'){
        this.linkActive = data
      }else{
        this.linkActive = ''
      }
    },
    logout(){
      swal("Are You Sure to Log Out?", '', "info", {
          buttons: ["Cancel", "Logout"]
      }).then((res) => {
          if(res) {
              this.$store.dispatch("logout");
          } else {
              if(swal.close()){
                  console.log("Cancel")
              }
          }
      })
      // this.$swal(
      //       "Are You Sure to Log Out?",
      //       "info",
      //       {
      //           buttons: ["Cancel", "Logout"]
      //       }
      //     ).then((res) => {
      //       if(res) {
      //         this.$store.dispatch("logout");
      //     } else {
      //         if(this.$swal.close()){
      //             console.log("Cancel")
      //         }
      //     }
      //     });
      
      
    }
  },
};
</script>
<style scoped>
::v-deep .main-sidebar, .datasidebar{
  height: 100vh !important;
  overflow-y: scroll;
  position: fixed !important;
}
.border-grey{
  border: 1px solid gray;
}
</style>
<style scoped>
.nav-item {
  font-size: 19px;
  padding: 0.5rem 0;
}
.nav-item i {
  font-size: 1.25rem;
}
.sidebar-color {
  background: #000000!important;
}
.nav-link {
  color: #fff !important;
}
.nav-link:hover {
  color: #ffffff !important;
  background-color: #2f303a!important;

}
</style>
